import React from 'react';

import styles from './ForgotPasswordStep4.module.scss';
import logo from "../../constants/images/logo.svg";
import ReturnToLoginPage from "../../components/UI/ReturnToLoginPage/ReturnToLoginPage";
import {MAIN_ROUTES} from "../../routing/main_routes";
import {useNavigate} from "react-router-dom";

const ForgotPasswordStep4 = () => {
    const navigate = useNavigate();

    return (
        <div className={styles.forgotPasswordStep4_wrapper}>
            <div className={styles.forgotPasswordStep4_wrapper_forgotPasswordStep4}>
                <div className={styles.forgotPasswordStep4_wrapper_forgotPasswordStep4_title}>
                    <img src={logo} alt="quality cleaning logo"/>

                    <div>
                        <h1 className={styles.title}>Пароль змінено</h1>
                        <p className={styles.paragraph}>Ваш пароль успішно скинуто. Клацніть нижче, щоб увійти.</p>
                    </div>
                </div>

                <button onClick={() => navigate(MAIN_ROUTES.LOGIN)} className={styles.forgotPasswordStep4_wrapper_forgotPasswordStep4_button}>Продовжити</button>

                <ReturnToLoginPage/>
            </div>
        </div>
    );
};

export default ForgotPasswordStep4;
